"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextColumnFilter = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TableProps = require("../TableProps");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TextColumnFilter = _ref => {
  let {
    column: {
      filterValue,
      preFilteredRows,
      setFilter,
      Header,
      id
    },
    placeHolder = {
      preText: 'Search',
      postText: 'records...'
    }
  } = _ref;
  const count = preFilteredRows.length;
  const placeholder = "".concat(placeHolder.preText, " ").concat(count, " ").concat(placeHolder.postText);
  return /*#__PURE__*/_react.default.createElement("input", {
    id: "".concat(id, "_filter_text"),
    title: placeholder,
    "aria-label": "Filter ".concat(Header),
    value: filterValue || '',
    onChange: e => {
      setFilter(e.target.value || undefined);
    },
    placeholder: placeholder
  });
};
exports.TextColumnFilter = TextColumnFilter;
TextColumnFilter.propTypes = {
  column: _propTypes.default.shape({
    Header: _propTypes.default.string,
    filterValue: _propTypes.default.string,
    preFilteredRows: _TableProps.RowsArrayProp,
    setFilter: _propTypes.default.func.isRequired,
    id: _propTypes.default.string
  }),
  placeHolder: _propTypes.default.shape({
    preText: _propTypes.default.string,
    postText: _propTypes.default.string
  })
};